import * as React from "react";
import { Helper } from "../../../Helper";
import { IEventSettings } from "../../../interfaces/IEventSettings";
import DateTimeService from "../../../services/DateTimeService";
import { Environment } from "../../../services/Environment";
import { LocalizationService } from "../../../services/LocalizationService";
import { IAMessageVideo } from "../../messages/video/MessageVideo";
import * as styles from "./CardCover.css";
import { IMessageIAMessageBgImagesFromBlob } from "../../../interfaces/IMessage";
import { IEnvironment } from "../../../interfaces/IEnvironment";

export interface ICardCoverProps {
  id?: string;
  imageURL?: string;
  iaMessageBgImagesFromBlob?: IMessageIAMessageBgImagesFromBlob;
  videoURL?: string;
  html?: JSX.Element;
  eventSettings: IEventSettings;
  height: number;
  isMobile: boolean;
  cropSettings?: { x: number, y: number, width: number, height: number };
  modified?: Date;
  token?: string;
  tenant?: string;
  environment?: IEnvironment;
  borderRadius?: number;
  onClickOpen: () => void;
  isPanelOpen?: boolean;
  showFullImage?: boolean;
}

export interface ICardCoverState {
}

export class IACardCover extends React.Component<ICardCoverProps, ICardCoverState> {

  private readonly dateTimeService: DateTimeService = new DateTimeService();
  private readonly localizationService: LocalizationService = new LocalizationService();

  constructor(props: ICardCoverProps) {
    super(props);
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public render(): JSX.Element {
    const showDateOnCover = this.props.eventSettings?.displayDateOnCover && !this.props.html;
    const isEventToday = this.props.eventSettings && this.props.eventSettings.startDate ? this.dateTimeService.ConvertToDDMMYYYY(this.props.eventSettings.startDate) === this.dateTimeService.ConvertToDDMMYYYY(new Date()) : undefined;
    const isOneDayEvent = this.props.eventSettings && this.props.eventSettings.startDate && this.props.eventSettings.endDate ? this.dateTimeService.isStartAndEndDateTheSameDay(this.props.eventSettings.startDate, this.props.eventSettings.endDate, this.props.eventSettings.isAllDayEvent) : undefined;
    const timespand = showDateOnCover && this.props.eventSettings && this.props.eventSettings.startDate && this.props.eventSettings.endDate ? this.dateTimeService.getEventString(this.props.eventSettings.startDate, this.props.eventSettings.endDate, this.props.eventSettings.isAllDayEvent) : undefined;
    let thumbnailImage = this.props.imageURL;
    if (this.props.iaMessageBgImagesFromBlob?.StandardSmall) {
      thumbnailImage = this.props.iaMessageBgImagesFromBlob?.StandardSmall;
    } else if (this.props.imageURL) {
      thumbnailImage = thumbnailImage.replace(/StandardLarge|StandardSmall|Square|Wide|Full|DefaultRendition/, "StandardSmall").replace("version=&", `version=${this.props.modified ? (new Date(this.props.modified)).toISOString().replace(/[^\d]/g, '') : ""}&ignoreCache=false&`);
      thumbnailImage = Helper.getImageUrl(Environment.getEnvironmentForImageAPI(this.props.environment), this.props.tenant, this.props.token, thumbnailImage, this.props.modified ? (new Date(this.props.modified)).toISOString().replace(/[^\d]/g, '') : undefined, "StandardSmall", this.props.cropSettings, false);
    }
    if (this.props.videoURL && (this.props.videoURL && this.props.videoURL.indexOf("microsoftstream") != -1) || (this.props.videoURL && this.props.videoURL.indexOf("sharepoint") != -1 && location.href.indexOf("sharepoint.com") == -1) && this.props.imageURL == undefined && this.props.isMobile) {
      thumbnailImage = "https://amsglob0cdnstream13.azureedge.net/streamlogo/Light_640x360.jpg";
    }
    if (!this.props.imageURL && this.props.videoURL && Helper.isYouTubeUrl(this.props.videoURL)) {
      thumbnailImage = Helper.getYouTubeThumbnailFromURL(this.props.videoURL);
    }
    return (
      <div
        className={styles.IA_cardCover}
        style={{
          height: this.props.height,
          borderRadius: this.props.borderRadius ? `${this.props.borderRadius}px ${this.props.borderRadius}px 0 0` : undefined,
          backgroundImage: `url("${thumbnailImage}")`,
          cursor: this.props.onClickOpen ? "pointer" : "default",
          backgroundRepeat: this.props.showFullImage ? "no-repeat" : undefined,
          backgroundSize: this.props.showFullImage ? "auto 100%" : undefined
        }}
        onClick={(this.props.imageURL || this.props.eventSettings || (this.props.videoURL?.indexOf("sharepoint") != -1 && location.href.indexOf("sharepoint.com") == -1) && !this.props.videoURL) ? (this.props.onClickOpen ? () => this.props.onClickOpen() : undefined) : undefined}
      >
        {showDateOnCover && this.props.eventSettings.startDate && !isOneDayEvent && !isEventToday &&
          <div className={styles.IA_coverOverlay} style={{ borderRadius: this.props.borderRadius }}>
            <div className={styles.IA_startDate}>
              {!this.props.eventSettings.isAllDayEvent
                ? `${this.dateTimeService.getDayInMonth(this.props.eventSettings.startDate)}. ${this.dateTimeService
                  .getNameOfMonth(this.props.eventSettings.startDate, this.props.eventSettings.isAllDayEvent)?.substring(0, 3)?.toUpperCase()}`
                : `${timespand.substring(0, 2)}. ${this.dateTimeService
                  .getNameOfMonth(this.props.eventSettings.startDate, this.props.eventSettings.isAllDayEvent)?.substring(0, 3)?.toUpperCase()}`}
            </div>
            <div className={styles.IA_startDateendDateDivider} />
            <div className={styles.IA_endDate}>
              {!this.props.eventSettings.isAllDayEvent
                ? `${this.dateTimeService.getDayInMonth(this.props.eventSettings.endDate)}. ${this.dateTimeService
                  .getNameOfMonth(this.props.eventSettings.endDate, this.props.eventSettings.isAllDayEvent)?.substring(0, 3)?.toUpperCase()}`
                : `${timespand.substring(8, 10)}. ${this.dateTimeService
                  .getNameOfMonth(this.props.eventSettings.endDate, this.props.eventSettings.isAllDayEvent)?.substring(0, 3)?.toUpperCase()}`}
            </div>
          </div>
        }
        {showDateOnCover && this.props.eventSettings.startDate && isOneDayEvent && !isEventToday &&
          <div className={styles.IA_coverOverlay} style={{ borderRadius: this.props.borderRadius }}>
            <div className={styles.IA_coverOverlayMonth}>
              {this.dateTimeService.getNameOfMonth(this.props.eventSettings.startDate, this.props.eventSettings.isAllDayEvent)?.substring(0, 3)?.toUpperCase()}
            </div>
            <div className={styles.IA_coverOverlayDay} style={{ borderRadius: this.props.borderRadius }}>
              {!this.props.eventSettings.isAllDayEvent
                ? this.dateTimeService.getDayInMonth(this.props.eventSettings.startDate)
                : timespand.substring(0, 2)}
            </div>
          </div>
        }
        {showDateOnCover && isEventToday && isOneDayEvent &&
          <div className={styles.IA_coverOverlay} style={{ borderRadius: this.props.borderRadius }}>
            <div className={styles.IA_coverOverlayToday}>{this.localizationService.strings.DateTimeService_Today?.toUpperCase()}</div>
          </div>
        }
        {showDateOnCover && isEventToday && !isOneDayEvent &&
          <div className={styles.IA_coverOverlay} style={{ borderRadius: this.props.borderRadius }}>
            <div className={styles.IA_coverOverlayMonth} style={{ marginTop: 0 }}>
              <div className={styles.IA_startDate}>{this.localizationService.strings.DateTimeService_Today?.toUpperCase()}</div>
              <div className={styles.IA_startDateendDateDivider} />
              <div className={styles.IA_endDate}>
                {!this.props.eventSettings.isAllDayEvent
                  ? `${this.dateTimeService.getDayInMonth(this.props.eventSettings.endDate)}. ${this.dateTimeService
                    .getNameOfMonth(this.props.eventSettings.endDate)?.substring(0, 3)?.toUpperCase()}`
                  : `${timespand.substring(8, 10)}. ${this.dateTimeService
                    .getNameOfMonth(this.props.eventSettings.endDate)?.substring(0, 3)?.toUpperCase()}`}
              </div>
            </div>
          </div>
        }
        {!this.props.eventSettings && !this.props.html && ((this.props.videoURL != undefined && this.props.imageURL == undefined) || this.props.videoURL != undefined && Helper.isMp3Audio(this.props.videoURL)) &&
          <IAMessageVideo
            id={this.props.id}
            width={"100%"}
            height={this.props.height}
            videoUrl={this.props.videoURL}
            environment={this.props.environment}
            tenant={this.props.tenant}
            token={this.props.token}
            thumbnailUrl={thumbnailImage}
            forceStop={this.props.isPanelOpen}
            fixSmallYTThumbnail
          />
        }
        {this.props.html &&
          this.props.html
        }
      </div>
    );
  }
}
